export const distinctBy = <T>(items: Array<T>, projection: (x: T) => string | number): Array<T> => {
	const source = items || ([] as Array<T>);
	const result = [] as Array<T>;
	const keys = new Set<string | number>();

	for (const c of source) {
		if (!keys.has(projection(c))) {
			keys.add(projection(c));
			result.push(c);
		}
	}

	return result;
};
